if (!customElements.get('rich-text-button')) {
  customElements.define(
    'rich-text-button',
    class RichTextButton extends HTMLElement {
      connectedCallback() {
        this.control = this.querySelector('[data-rich-text-action]');
        if (!this.control) return;
        this.onClick = this.onClick.bind(this);
        this.control.addEventListener('click', this.onClick);
      }

      disconnectedCallback() {
        if (this.control && this.onClick) {
          this.control.removeEventListener('click', this.onClick);
        }
      }

      onClick(event) {
        const action = this.control.dataset.richTextAction;
        if (action === 'scroll') {
          event.preventDefault();
          this.scrollToTarget(this.control.dataset.scrollTarget);
          return;
        }
        if (action === 'add-to-cart') {
          event.preventDefault();
          this.addToCart();
        }
      }

      getProductForm() {
        return (
          document.querySelector('product-info form.main-product-form[is="product-form"]') ||
          document.querySelector('form.main-product-form[is="product-form"]')
        );
      }

      getAtcElement() {
        const form = this.getProductForm();
        if (form) return form;
        return (
          document.querySelector('product-info') ||
          document.querySelector('.product-form__submit') ||
          document.querySelector('[id^="MainProduct-"]')
        );
      }

      resolveTarget(id) {
        if (!id) return this.getAtcElement();
        const cleaned = String(id).replace(/^#/, '').trim();
        if (!cleaned) return this.getAtcElement();

        const escaped = typeof CSS !== 'undefined' && CSS.escape ? CSS.escape(cleaned) : cleaned.replace(/[^a-zA-Z0-9_-]/g, '');
        return (
          document.getElementById(cleaned) ||
          document.getElementById(`shopify-section-${cleaned}`) ||
          document.getElementById(`MainProduct-${cleaned}`) ||
          (escaped ? document.querySelector(`[id$="__${escaped}"]`) : null) ||
          this.getAtcElement()
        );
      }

      getScrollOffset() {
        let offset = 20;
        const headerEl = document.querySelector('[data-sticky-header]');
        if (headerEl) {
          const height = Math.round(headerEl.offsetHeight);
          if (headerEl.isAlwaysSticky) {
            offset += height;
          } else {
            const pinnedClass = headerEl.classes && headerEl.classes.pinned;
            const pinned = pinnedClass ? document.body.classList.contains(pinnedClass) : false;
            if (pinned || window.scrollY > 0) {
              offset += height;
            }
          }
        }
        return offset;
      }

      scrollToElement(el) {
        if (!el) return;
        const top = el.getBoundingClientRect().top + window.scrollY - this.getScrollOffset();
        window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
      }

      scrollToTarget(id) {
        this.scrollToElement(this.resolveTarget(id));
      }

      setLoading(isLoading) {
        this.control.classList.toggle('btn--loading', isLoading);
        this.control.toggleAttribute('aria-busy', isLoading);
        if (isLoading) {
          this.control.setAttribute('disabled', 'true');
        } else {
          this.control.removeAttribute('disabled');
        }
      }

      addToCart() {
        const form = this.getProductForm();
        if (!form) {
          this.scrollToElement(this.getAtcElement());
          return;
        }

        const submit = form.querySelector('[name="add"], .product-form__submit[type="submit"]');
        if (!submit || submit.disabled || submit.hasAttribute('aria-disabled')) {
          this.scrollToElement(form);
          return;
        }

        if (this.isAdding) return;
        this.isAdding = true;
        this.setLoading(true);

        const finish = () => {
          if (!this.isAdding) return;
          this.isAdding = false;
          this.setLoading(false);
          document.removeEventListener('product-ajax:added', finish);
          document.removeEventListener('product-ajax:error', finish);
        };

        document.addEventListener('product-ajax:added', finish);
        document.addEventListener('product-ajax:error', finish);
        window.setTimeout(finish, 10000);

        form.requestSubmit(submit);
      }
    }
  );
}
